export class EditRequest {
  force: boolean;
}
